import { computed } from "vue";
import { DS_PROGRESS_COMPLETE } from "@/src/design_system/feedback/progress_bar/constants/progress";
import { DS_FILE_UPLOAD_CLASSES } from "../constants/classes";
import type { ComputedRef, Ref } from "vue";
import type { DSFileUploadComponentProps, DSFileUploadModelValue } from "../types";

interface UseDSFileUploadPresentationOptions {
  props: DSFileUploadComponentProps;
  modelValue: Readonly<Ref<DSFileUploadModelValue>>;
  fieldErrorMessages: ComputedRef<string[]>;
  isDragActive: Readonly<Ref<boolean>>;
  isDropzoneFocused: Readonly<Ref<boolean>>;
}

export function useDSFileUploadPresentation({
  props,
  modelValue,
  fieldErrorMessages,
  isDragActive,
  isDropzoneFocused,
}: UseDSFileUploadPresentationOptions) {
  const hasError = computed(() => {
    return Boolean(fieldErrorMessages.value.length || modelValue.value.some(item => item.errorMessages?.length));
  });
  const showProgressBar = computed(() => props.progress !== undefined);
  const isUploading = computed(() => props.progress !== undefined && props.progress < DS_PROGRESS_COMPLETE);
  const showFiles = computed(() => props.showFileList && modelValue.value.length > 0);

  const rootClasses = computed(() => ({
    [DS_FILE_UPLOAD_CLASSES.Root]: true,
    [DS_FILE_UPLOAD_CLASSES.Default]: true,
    [DS_FILE_UPLOAD_CLASSES.DragActive]: isDragActive.value,
    [DS_FILE_UPLOAD_CLASSES.Loading]: isUploading.value,
    "is-focused": isDropzoneFocused.value,
    "is-disabled": props.disabled,
    "is-error": hasError.value,
  }));

  return {
    hasError,
    rootClasses,
    showFiles,
    showProgressBar,
  };
}
